import * as ActionTypes from "../actions/types";

const INITIAL_STATE = {
  loading: false,
  contact: {
    success: false,
    message: "",
    resetForm: false,
  },
};

function contactFormSendMessage(state) {
  state.loading = true;
}

function contactFormMessageSent(state, action) {
  state.contact.message =
    action.payload?.message || "Your message has been sent successfully.";
  state.contact.success =
    action.payload?.success !== undefined ? action.payload.success : true;
  state.contact.resetForm =
    action.payload?.resetForm !== undefined ? action.payload.resetForm : true;
  state.loading = false;
}

function contactFormMessageFailed(state, action) {
  const response =
    action.payload?.message ||
    action.payload?.error?.response?.body?.message ||
    action.payload?.[0]?.response?.body?.message ||
    "There was a problem while sending your message. Try again later.";
  state.contact.message = response;
  state.contact.success = false;
  state.loading = false;
}

function clearContactStatusMessages(state) {
  state.contact.message = "";
  state.contact.success = false;
  state.contact.resetForm = false;
  state.loading = false;
}

export const contact = {
  initialState: INITIAL_STATE,
  handlers: {
    [ActionTypes.SEND_CONTACT_FORM]: contactFormSendMessage,
    [ActionTypes.SEND_CONTACT_FORM_FAILED]: contactFormMessageFailed,
    [ActionTypes.SEND_CONTACT_FORM_SUCCESS]: contactFormMessageSent,
    [ActionTypes.CLEAR_CONTACT_FORM_MESSAGES]: clearContactStatusMessages,
  },
};
